<section class="section">
    <div class="section-body">
    <div class="row" >
<div class="col-12 col-md-12 col-lg-12">
    <div class="card card-success">
        <div class="card-header">
          <h4>BIZ File Upload</h4>
          <!-- <div class="card-header-action">
            <a data-toggle="collapse" class="btn btn-icon btn-success" href="#referralAmount-collapse">
              <i class="fas fa-minus"></i></a>
          </div> -->
        </div>
    <div class="registerdata form-group">
        <div class="form-line">
            <!-- <label class="form-label">Upload Photo</label> -->
            <div class="row">
                <div class="col-md-10">
                    <div class="form-group ml-5 mt-5">
                        
                        <!-- <input type="file" id="file_up" class="files"> -->
                        <input type="file" id="file_up" name="img[]" class="file" (change)="fileChange($event)">
                        <div class="input-group mb-3">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1"><i class="fas fa-paperclip"></i></span>
                          </div>
                          <input type="text" class="form-control" disabled placeholder="Upload File" aria-label="Upload File" aria-describedby="basic-addon1">
                          <div class="input-group-append">
                            <button class="browse input-group-text btn btn-primary" id="basic-addon2"><i class="fas fa-search"></i>  Browse</button>
                          </div>
                        </div>
                      </div>
                </div>
                <div class="col-md-2">
                    <div>
                        <button class="btn btn-dark ml-2 mt-5" id="submit" (click)="submit()">
                            Submit
                        </button>
                    </div>
                </div>
                <div class="col-md-1">
                </div>
                <!-- <div class="col-md-10">
                    <img onerror="" class="img-thumbnail imguploadthumb" src="">
                </div> -->
                    <!-- <div class="col-md-1">

                  </div> -->
            </div>
         </div>
    </div>
</div>
</div>
</div>
</div>
</section>
